import { render, staticRenderFns } from "./BuscadorRequerimientos.vue?vue&type=template&id=315d9a96&scoped=true"
import script from "./BuscadorRequerimientos.vue?vue&type=script&lang=js"
export * from "./BuscadorRequerimientos.vue?vue&type=script&lang=js"
import style0 from "./BuscadorRequerimientos.vue?vue&type=style&index=0&id=315d9a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d9a96",
  null
  
)

export default component.exports